"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFileDrop = exports.FileDropProvider = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("./utils");
var FileDropContext = (0, react_1.createContext)({});
var FileDropProvider = function (_a) {
    var className = _a.className, children = _a.children;
    var _b = (0, react_1.useState)([]), listeners = _b[0], setListeners = _b[1];
    var _c = (0, react_1.useState)(false), active = _c[0], setActive = _c[1];
    var onDragOver = function (event) {
        event.preventDefault();
        setActive(true);
    };
    var onDragLeave = function () {
        setActive(false);
    };
    var onDrop = (0, react_1.useCallback)(function (event) {
        event.preventDefault();
        var dataTransfer = event.dataTransfer;
        if (dataTransfer && (dataTransfer === null || dataTransfer === void 0 ? void 0 : dataTransfer.files.length) > 0) {
            var file_1 = dataTransfer.files[0];
            file_1
                .arrayBuffer()
                .then(function (buffer) {
                listeners
                    .filter(function (_a) {
                    var type = _a[0];
                    return file_1.type ? type === file_1.type : (0, utils_1.isFileType)(buffer, type);
                })
                    .forEach(function (_a) {
                    var listener = _a[1];
                    return listener(file_1.name, buffer);
                });
            });
        }
        setActive(false);
    }, [listeners]);
    var on = function (type, listener) {
        setListeners(function (listeners) {
            return __spreadArray(__spreadArray([], listeners, true), [[type, listener]], false);
        });
    };
    var off = function (type, listener) {
        setListeners(function (listeners) {
            return listeners.filter(function (_a) {
                var key = _a[0], value = _a[1];
                return key !== type && value !== listener;
            });
        });
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener('dragover', onDragOver);
        window.addEventListener('dragleave', onDragLeave);
        window.addEventListener('drop', onDrop);
        return function () {
            window.removeEventListener('dragover', onDragOver);
            window.removeEventListener('dragleave', onDragLeave);
            window.removeEventListener('drop', onDrop);
        };
    }, [onDrop]);
    return (react_1.default.createElement(FileDropContext.Provider, { value: { on: on, off: off } },
        children,
        react_1.default.createElement("div", { className: (0, classnames_1.default)(className, { 'active': active }) })));
};
exports.FileDropProvider = FileDropProvider;
var useFileDrop = function () {
    return (0, react_1.useContext)(FileDropContext);
};
exports.useFileDrop = useFileDrop;
